import React from 'react'
import styled from 'styled-components'

const HomeDirectory = ({ children }) => {
  return (
    <Wrapper>
      <Container>{children}</Container>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;

  li {
    font-family: var(--font-display);
    font-size: var(--font-size-6);
    line-height: var(--font-lineheight-6);
    font-weight: var(--font-weight-7);
    text-transform: uppercase;

    @media (min-width: 768px) {
      font-size: var(--font-size-8);
      line-height: var(--font-lineheight-8);
    }
  }

  div > ul > li {
    margin: 1em 0;
  }

  ul > li > ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        color: var(--color-text2);
        white-space: nowrap;
        transition: color 250ms;

        &:hover,
        &:active {
          color: var(--color-secondary);
        }

        &::after {
          bottom: 0.1em;
        }
      }

      &:not(:last-child) {
        &::after {
          content: ' • ';
          margin: 0 0.2em;
          color: var(--color-text2);
        }
      }
    }
  }
`

const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--padding-x);
`

export default HomeDirectory
